import styled from '@emotion/styled';
import { Flex } from '@revenuemarket/cds';
import { colorTokens } from '@revenuemarket/design';

export const Section = styled(Flex)`
  background: white;
  border-bottom: 1px solid ${colorTokens.borderDefault};
`;
